import { useQuery } from "convex/react";

import { api } from "../../convex/_generated/api";
import type { Id } from "../../convex/_generated/dataModel";
import type { BusinessMembership, CurrentMembership } from "./types";
import { WhatsAppConnectionPanel } from "./WhatsAppConnectionPanel";
import { WorkspaceSetupDetail } from "../workspace/WorkspaceSetupDetail";

export function WhatsAppConnectionSetupPage({
  business,
  embedded = false,
  onSignOut,
}: {
  business: BusinessMembership;
  embedded?: boolean;
  onSignOut: () => void;
}) {
  const currentMembership = useQuery(api.memberships.getForBusiness, {
    businessId: business.businessId,
  }) as CurrentMembership | undefined;

  const panel = (
    <WhatsAppConnectionPanel
      businessId={business.businessId as Id<"businesses">}
      currentMembership={currentMembership ?? null}
    />
  );

  if (embedded) {
    return (
      <WorkspaceSetupDetail
        description="Connect and verify the provider-backed WhatsApp number for this business."
        eyebrow="WhatsApp connection"
        title="Connect WhatsApp"
      >
        {panel}
      </WorkspaceSetupDetail>
    );
  }

  return (
    <main className="foundation-shell connection-setup-shell">
      <section aria-live="polite" className="status-panel">
        <span className="status-label">WhatsApp connection</span>
        <strong>{business.name}</strong>
        <span>{business.role} workspace</span>
        <button onClick={onSignOut} type="button">
          Sign out
        </button>
      </section>
      {panel}
    </main>
  );
}
